// TODO: basic wiring is done but it needs work to make dark theme visuals prettier
export type AssistantModalTheme = 'light' | 'dark';

interface AssistantModalTokens {
  paperBg: string;
  headerBg: string;
  surface: string;
  surface2: string;
  border: string;
  borderMid: string;
  borderHeavy: string;
  textPrimary: string;
  textSecondary: string;
  textDisabled: string;
  inputBg: string;
  cancelBorder: string;
  cancelHoverBg: string;
  cancelHoverBorder: string;
  backdrop: string;
  accentSurface: string;
}

const lightTokens: AssistantModalTokens = {
  paperBg: '#ffffff',
  headerBg: '#ffffff',
  surface: '#fafafa',
  surface2: '#f5f5f5',
  border: '#eeeeee',
  borderMid: '#e0e0e0',
  borderHeavy: '#bdbdbd',
  textPrimary: 'rgba(0,0,0,0.87)',
  textSecondary: 'rgba(0,0,0,0.6)',
  textDisabled: 'rgba(0,0,0,0.38)',
  inputBg: 'transparent',
  cancelBorder: '#e0e0e0',
  cancelHoverBg: '#fafafa',
  cancelHoverBorder: '#bdbdbd',
  backdrop: 'rgba(0,0,0,0.5)',
  accentSurface: 'rgba(69,84,229,0.07)',
};

const darkTokens: AssistantModalTokens = {
  paperBg:
    'linear-gradient(135deg, rgba(35,38,47,0.98) 0%, rgba(18,18,22,0.98) 100%)',
  headerBg: 'rgba(25,25,30,0.98)',
  surface: 'rgba(255,255,255,0.04)',
  surface2: 'rgba(255,255,255,0.06)',
  border: 'rgba(255,255,255,0.08)',
  borderMid: 'rgba(255,255,255,0.12)',
  borderHeavy: 'rgba(255,255,255,0.2)',
  textPrimary: '#ffffff',
  textSecondary: 'rgba(255,255,255,0.6)',
  textDisabled: 'rgba(255,255,255,0.3)',
  inputBg: 'rgba(25,25,30,0.8)',
  cancelBorder: 'rgba(255,255,255,0.2)',
  cancelHoverBg: 'rgba(255,255,255,0.04)',
  cancelHoverBorder: 'rgba(255,255,255,0.4)',
  backdrop: 'rgba(0,0,0,0.7)',
  accentSurface: 'rgba(69,84,229,0.12)',
};

export const modalThemeTokens: Record<
  AssistantModalTheme,
  AssistantModalTokens
> = {
  light: lightTokens,
  dark: darkTokens,
};

export function buildModalCssVars(
  tokens: AssistantModalTokens,
): Record<string, string> {
  return {
    '--am-paper-bg': tokens.paperBg,
    '--am-header-bg': tokens.headerBg,
    '--am-surface': tokens.surface,
    '--am-surface-2': tokens.surface2,
    '--am-border': tokens.border,
    '--am-border-mid': tokens.borderMid,
    '--am-border-heavy': tokens.borderHeavy,
    '--am-text-primary': tokens.textPrimary,
    '--am-text-secondary': tokens.textSecondary,
    '--am-text-disabled': tokens.textDisabled,
    '--am-input-bg': tokens.inputBg,
    '--am-cancel-border': tokens.cancelBorder,
    '--am-cancel-hover-bg': tokens.cancelHoverBg,
    '--am-cancel-hover-border': tokens.cancelHoverBorder,
    '--am-backdrop': tokens.backdrop,
    '--am-accent-surface': tokens.accentSurface,
  };
}
